var data = {
  danjiaModel: {
    name: "单价",
    startAdd: "深圳-440300",
    endAdd: "香港-810000",
    unit: ["RMB"],
    startPirce: 0,
    startPirceIn: 0,
    function: "danjiaPrice(0,0)",
    list: [
      {
        name: "元",
        unit: ["KGS"],
        price: 0
      },
      {
        name: "元",
        unit: ["CBM"],
        price: 0
      },
      {
        name: "元",
        unit: ["件"],
        price: 0
      },
      {
        name: "元",
        unit: ["P/L"],
        price: 0
      }
    ]
  },
  guoBanModel: {
    name: "单价",
    startAdd: "深圳-440300",
    endAdd: "香港-810000",
    unit: ["RMB"],
    startPirce: 0,
    startPirceIn: 0,
    function: "",
    list: [
      {
        name: "元",
        unit: ["KGS"],
        price: 0
      },
      {
        name: "元",
        unit: ["CBM"],
        price: 0
      },
      {
        name: "元",
        unit: ["件"],
        price: 0
      },
      {
        name: "元",
        unit: ["P/L"],
        price: 0
      }
    ]
  },
  danjiaModel2: {
    name: "车型",
    startPirce: 0,
    startPirceIn: 0,
    function: "danjiaPrice(0,0)",
    startAdd: "深圳-440300",
    endAdd: "香港-810000",
    transportType: 0, //运输方式 0--往返，1：直达
    unit: ["KGS", "CBM", "P/L"],
    list: [
      {
        name: "",
        unit: ["0-2", "0-2", "0-2"],
        price: 0,
        function: "rangeDanjia(0,0,0,0)"
      },
      {
        name: "",
        unit: ["0-4", "0-2", "0-2"],
        price: 0,
        function: "rangeDanjia(0,0,0,0)"
      },
      {
        name: "",
        unit: ["0-5", "0-2", "0-2"],
        price: 0,
        function: "rangeDanjia(0,0,0,0)"
      }
    ]
  },
  baoguanModel: {
    name: "单价",
    startAdd: "深圳",
    endAdd: "香港",
    unit: ["RMB"],
    list: [
      /* {
        name: "手册",
        unit: ["手册"],
        function:'danjia(0,"份","人民币")',
        price: 0
      },
      {
        name: "买单",
        unit: ["买单"],
        function:'danjia(0,"份","人民币")',
        price: 0
      },
      {
        name: "无缝对接",
        unit: ["无缝对接"],
        function:'danjia(0,"份","人民币")',
        price: 0
      },
      {
        name: "香港报关",
        unit: ["香港报关"],
        function:'huoZhi(0/10000,0,"港元")',
        price: 0
      } */
    ]
  },

  pincheModel: {
    name: "车型",
    startAdd: "深圳-440300",
    endAdd: "香港-810000",
    startPirce: 0,
    startPirceIn: 0,
    function: "pinchePrice(0,0)",
    transportType: 0, //运输方式 0--往返，1：直达
    unit: ["KGS", "CBM", "P/L"],
    list: [
      {
        name: "",
        unit: ["0-2", "0-2", "0-2"],
        price: 0
      },
      {
        name: "",
        unit: ["0-4", "0-2", "0-2"],
        price: 0
      },
      {
        name: "",
        unit: ["0-5", "0-2", "0-2"],
        price: 0
      }
    ]
  },
  zhuancheModel: {
    name: "车型",
    startAdd: "深圳-440300",
    endAdd: "香港-810000",
    startPirce: 0,
    startPirceIn: 0,
    function: "zhuanchePrice(0,0)",
    transportType: 0, //运输方式 0--往返，1：直达
    unit: ["KGS", "CBM", "P/L", "P/L1"],
    list: [
      {
        name: "3T",
        unit: [1800, 13, 3, 0],
        price: 0
      },
      {
        name: "8T",
        unit: [6000, 30, 8, 0],
        price: 0
      },
      {
        name: "10T",
        unit: [7000, 33, 10, 0],
        price: 0
      },
      {
        name: "12T",
        unit: [10000, 35, 12, 0],
        price: 0
      }
    ]
  },
  zhuancheModel2: {
    name: "车型",
    startAdd: "深圳-440300",
    endAdd: "香港-810000",
    startPirce: 0,
    startPirceIn: 0,
    function: "zhuanchePrice(0,0)",
    transportType: 0, //运输方式 0--往返，1：直达
    unit: ["KGS", "CBM", "P/L", "P/L1"],
    list: [
      {
        name: "3T",
        unit: [1800, 13, 3, 0],
        function: "discount(0,0)"
      },
      {
        name: "8T",
        unit: [6000, 30, 8, 0],
        function: "discount(0,0)"
      },
      {
        name: "10T",
        unit: [7000, 33, 10, 0],
        function: "discount(0,0)"
      },
      {
        name: "12T",
        unit: [10000, 35, 12, 0],
        function: "discount(0,0)"
      }
    ]
  },
  kuliModel: [
    [
      {
        name: "件数",
        unit: "KGS,CBM",
        list: [
          {
            name: "0-50,10-20",
            price: 0
          },
          {
            name: "50-100,30-40",
            price: 0
          }
        ]
      },
      {
        name: "板数",
        unit: "KGS,CBM",
        list: [
          {
            name: "0-50,10-20",
            price: 0
          },
          {
            name: "50-100,30-40",
            price: 0
          }
        ]
      }
    ],
    [
      {
        name: "件数",
        unit: "KGS,CBM",
        list: [
          {
            name: "0-50,10-20",
            price: 0
          },
          {
            name: "50-100,30-40",
            price: 0
          }
        ]
      },
      {
        name: "板数",
        unit: "KGS,CBM",
        list: [
          {
            name: "0-50,10-20",
            price: 0
          },
          {
            name: "50-100,30-40",
            price: 0
          }
        ]
      }
    ]
  ],
  shouHuoSongHuoModel: {
    name: "车型",
    startAdd: "深圳-440300",
    endAdd: "深圳-440300",
    transportType: 0,

    unit: ["KGS", "CBM", "P/L"],
    list: [
      {
        name: "3T",
        unit: ["0-2", "0-2", "0-2"],
        price: 0
      },
      {
        name: "5T",
        unit: ["0-4", "0-2", "0-2"],
        price: 0
      },
      {
        name: "15T",
        unit: ["0-5", "0-2", "0-2"],
        price: 0
      }
    ]
  },
  zhuangxieModel: {
    name: "单价",
    startAdd: "深圳",
    endAdd: "香港",
    unit: ["RMB"],
    zxConfig: {
      type: "卸货", //装卸方式,
      currency: "港元",
      area: "香港" //装卸区域
    },
    list: [
      {
        name: "元",
        unit: ["KGS"],
        price: 0
      },
      {
        name: "元",
        unit: ["CBM"],
        price: 0
      },
      {
        name: "元",
        unit: ["件"],
        price: 0
      },
      {
        name: "元",
        unit: ["P/L"],
        price: 0
      }
    ]
  },
  zhuangxieModel2: {
    name: "车型",
    startPirce: 0,
    startPirceIn: 0,
    function: "zhuangXiePrice(0,0)",
    startAdd: "深圳-440300",
    endAdd: "香港-810000",
    transportType: 0, //运输方式 0--往返，1：直达
    unit: ["KGS", "CBM", "P/L", "件"],
    list: [
      {
        name: "",
        unit: ["0-999999", "0-999999", "0-999999", "0-999999"],
        price: 0,
        function: "rangeZhuangXie(0,0,0,0)"
      }
    ]
  },
  zidian: {
    danjia: "中港运输拼车v1.0(单价计费)",
    danjia2: "中港运输拼车v2.0(单价计费)",
    zhuangXie: "装货/卸货费v1.0",
    zhuangXie2: "装货/卸货费v2.0",
    pinche: "中港运输拼车(区间计费)",
    zhuanche: "中港运输专车(区间计费)",
    zhuanche2: "中港运输专车(区间计费(含优惠))",
    shouHuoSongHuo: "大陆提货/送货费",
    kuli: "香港提货/送货费",
    other: "其他费",
    common: "附加费",
    baoguan: "报关费",
    guoBan: "过板费"
  }
};
export default data;



// WEBPACK FOOTER //
// ./src/components/wuliu/kehu/baojia/modelData.js